import { IDataSourceInfo } from '~src/ts/models/IDataSourceInfo';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { INamedItemInfo } from '../../../ts/models/resourceInfoParts';
import { editWorkbook } from '../../actions/spaces/EditWorkbookAction';
import { getAppStore } from '../../AppStore';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { EntityLinkProps } from './Elements/EntityLink';

export interface ContentTooltipProps {
  content: IContentInfo;
  urls: SpacesSiteUrls;
  inProjectSpace?: boolean;
  inPersonalSpace?: boolean;
  lastUpdatedTimestamp?: Date;
  draftLastUpdatedTimeStamp?: string;
}

export const TooltipDescriptionTestId = 'tooltip-description-field';

export const ContentDescriptionClassNames = [
  'tb-textile',
  'tb-textile-preview-container',
  DetailsTooltipStyles.MetadataValueContentDescription
].join(' ');

export const getProjectLink = (project: INamedItemInfo, urls: SpacesSiteUrls): EntityLinkProps => {
  return project ? {
    href: urls.projectUrl(project.id),
    iconImagePath: null,
    name: project.name
  } : null;
};

export function handleContinueEditingAction(content: IContentInfo): () => void {
  return () => {
      if (content.contentType === 'workbook') {
          getAppStore().dispatch(editWorkbook(content));
      }
  };
}

export interface StatusTooltipProps {
  content: IDataSourceInfo;
  urls: SpacesSiteUrls;
  federatedCount?: number;
}
